import { StripeActionButton, type WrapperFC } from '@george-labs.com/design-system';

import { isFeatureEnabled } from '@luna/gatekeeper';
import { useNotifications } from '@shared/snackbar';
import { t } from '@luna/i18n';
import { logger } from '@luna/logger';

import { invalidateUnreadBankMessages, useUnreadBankMessages } from '../useUnreadBankMessages';
import { invalidateBankMessages } from '../useBankMessages';
import { useMarkAllMessagesAsRead } from './useMarkAllMessagesAsRead';
import { trackAllBankMessagesMarkedAsRead } from '../BankMessagesTrackingService';

export const BankMessagesStripeActionButton: WrapperFC = () => {
    const { data: unreadBankMessages = [] } = useUnreadBankMessages();
    const { mutate: markAllMessagesAsRead, isPending: isMarkingAsRead } =
        useMarkAllMessagesAsRead();
    const { displayError } = useNotifications('mark-all-messages-as-read');

    const isDisabled = isMarkingAsRead || unreadBankMessages.length === 0;

    const handleMarkAllAsRead = async () => {
        try {
            trackAllBankMessagesMarkedAsRead();
            await markAllMessagesAsRead();
            invalidateBankMessages();
            invalidateUnreadBankMessages();
        } catch (err) {
            logger.error(err);
            displayError(t('bankMessages.markAllAsReadError'));
        }
    };

    if (!isFeatureEnabled((f) => f.bankMessages.markAllAsRead)) {
        return null;
    }

    return (
        <StripeActionButton
            disabled={isDisabled}
            isLoading={isMarkingAsRead}
            data-cy="mark-all-messages-as-read"
            onClick={handleMarkAllAsRead}
            icon={StripeActionButton.ICON.CHECKMARK_CIRCLE}
        >
            {t('bankMessages.markAllAsReadButton')}
        </StripeActionButton>
    );
};

BankMessagesStripeActionButton.wrapsComponent = StripeActionButton;
